import { Component, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ConfigService } from '../../services/config/config.service';
import { TermsAndConditionsService } from '../../services/terms-and-conditions/terms-and-conditions.service';
import { AuthService } from '../../services/auth/auth.service';
import { VideoPortalUser } from '../../services/auth/video-portal-user.model';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy {
    environment: string;
    productName: string;
    @ViewChild('termsAndConditionsButton') termsAndConditionsButton: ElementRef;
    version: string;
    year: number;
    currentUser: VideoPortalUser | null = null;
    private destroy$ = new Subject<void>();

    get showCouncilSupportEmail(): boolean {
        return !!this.currentUser && this.currentUser.isInRole("council");
    }

    get showJjrSupportEmail(): boolean {
        return !!this.currentUser && this.currentUser.isInRole("jjr");
    }

    constructor(configService: ConfigService,
                private termsAndConditionsService: TermsAndConditionsService,
                private authService: AuthService) {
        this.environment = configService.config.environment;
        this.productName = configService.config.productName;
        this.version = configService.config.version;
        this.year = new Date().getFullYear();
        this.termsAndConditionsService.shown.subscribe(() => {
            /*this.termsAndConditionsButton.nativeElement.click();*/
        });
    }

    ngOnInit(): void {
        this.authService.userInfoSubject
            .pipe(takeUntil(this.destroy$))
            .subscribe(user => {
                this.currentUser = user;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
